import { ENV, isRealProd, MARKETING } from '../env';

const domainOnlineMy = 'https://global.mplusonline.com/';
const domainOnlineSg = 'https://www.tickrs.com.sg/';
const domainFinanceHk = 'https://www.vbkr.com/';

// 当前页面内的域名
const getSGDomain = () => {
	if (ENV === 'prod') {
		return domainOnlineSg;
	}
	return `https://${ENV}.tickrs.com.sg`;
};

const getMyDomain = () => {
	if (ENV === 'prod') {
		return domainOnlineMy;
	}
	return `https://mobile-${ENV}.mplusglobal.com.my/`;
};

const getHKDomain = () => {
	if (ENV === 'prod') {
		return domainFinanceHk;
	}
	return `https://${ENV}.vbkr.com/`;
};

// 登录的域名
const getOldHostMy = () => {
	if (isRealProd) {
		return 'global.mplusonline.com';
	}
	return `mplusglobal.com.my`;
};
const getOldHostSg = () => {
	if (isRealProd) {
		return 'tickrs.com.sg/';
	}
	return `mplusglobal.com.my`;
};
export const getOldHostHk = () => {
	// if (!process.client) return `vbkr.com`;
	const host = window.location.host;
	return host.split('.').slice(1).join('.');
};

// 登录的域名
const getLoginHostMy = () => {
	const oldHost = getOldHostMy();
	if (isRealProd) {
		return `https://${oldHost}`;
	}
	return `https://${ENV}.${oldHost}`;
};
const getLoginHostSg = () => {
	const oldHost = getOldHostSg();
	if (isRealProd) {
		return `https://www.${oldHost}`;
	}
	return `https://${ENV}.${oldHost}`;
};
export const getLoginHostHk = () => {
	const oldHost = getOldHostHk();
	if (isRealProd) {
		return `https://www.${oldHost}`;
	}
	return `https://${ENV}.${oldHost}`;
};

const commonInfos = {
	MY: {
		domain: getMyDomain(),
		login: getLoginHostMy(),
		old: getLoginHostMy(),
	},
	SG: {
		domain: getSGDomain(),
		login: getLoginHostSg(),
		old: getLoginHostSg(),
	},
	HK: {
		domain: getHKDomain(),
		login: getLoginHostHk(),
		old: getLoginHostHk(),
	},
};

const DomainsOfCommon = commonInfos[MARKETING];

export default DomainsOfCommon;
